export const overlayBoolean = (value: unknown, field: unknown): unknown | undefined => {
  if (typeof field !== 'boolean' || typeof value !== 'boolean') return undefined
  return field
}
